import Chart from 'chart.js';
import GenericGraphic from './GenericGraphic.js';
import { formatCurrency, formatTooltipCommon, maxLenghtYLabel } from '../../functions/formatGraphic.js';


/**
 * Class para criação de Cráfico do tipo de Horzontal
 */
class Horizontal extends GenericGraphic {

  constructor(element, data) {
    super(data);
    this.element = element;
  }

  /**
   * Método de criação de gráficos,
   * seguindo a estrutura do Chartjs,
   * incluindo as opçõe que podem ser atribuídas
   *
   * @return {Charjs} Instância de Chartjs do tipo Horizontal
   */
  createChart() {
    return new Chart(this.element, {
      type: 'horizontalBar',
      data: {
        labels: this.labels,
        datasets: [{
          label: '',
          backgroundColor: 'rgba(0,157,179, .8)',
          data: this.dataSet
        }]
      },
      options: {
        responsive: true,
        maintainAspectRatio: false,
        legend: {
          display: false,
          hidden: true
        },
        tooltips: {
          callbacks: {
            title: function () {
              return '';
            },
            label: function(tooltipItem, data) {
              return formatTooltipCommon(tooltipItem, data);
            }
          }
        },
        scales: {
          yAxes:[{
            ticks: {
              callback: function (value) {
                return maxLenghtYLabel(value, 12);
              }
            }
          }],
          xAxes: [{
            stacked: true,
            ticks: {
              callback: function (value) {
                return formatCurrency(value);
              }
            }
          }]
        }
      }
    });
  }
}
export default Horizontal;
